export const Lista_Frecuencia = [
    "1-2 veces a la semana",
    "3-5 veces a la semana",
    "Más de 5 veces a la semana",
] as const;